/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Thermalshockschedule2Inputs */



/**
* | output |
* | --- |
* | "Anti-thermal shock schedule" |
*
* @param {Br_History_Key_Thermalshockschedule2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_thermalshockschedule2 = /** @type {((inputs?: Br_History_Key_Thermalshockschedule2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Thermalshockschedule2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Anti-thermal shock schedule")
	return /** @type {LocalizedString} */ ("Planning anti-choc thermique")
});
export { br_history_key_thermalshockschedule2 as "br_history_key_thermalShockSchedule" }